export async function openDB(name, store) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(name, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(store);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function dropDB(name) {
  return new Promise((resolve, reject) => {
    const req = indexedDB.deleteDatabase(name);
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
    req.onblocked = () => {
      console.warn('Unable to delete, db is blocked.');
    };
  });
}

export async function putItem(db, store, key, value) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(store, 'readwrite');
    let objectStore;
    try {
      objectStore = transaction.objectStore(store);
    } catch {
      reject(new Error(`ObjectStore "${store}" does not exist.`));
      return;
    }

    const payload = { value };
    if (value instanceof File) {
      payload.fileMetadata = {
        name: value.name,
        type: value.type,
        lastModified: value.lastModified,
      };
    }
    const request = objectStore.put(payload, key);

    request.onsuccess = () => resolve(key);
    request.onerror = () => reject(request.error);
  });
}

export async function getItem(db, store, key) {
  return new Promise((resolve, reject) => {
    let objectStore;
    try {
      const transaction = db.transaction(store, 'readonly');
      objectStore = transaction.objectStore(store);
    } catch {
      resolve(null);
      return;
    }
    const request = objectStore.get(key);
    request.onsuccess = () => {
      const { result } = request;
      if (!result) {
        return resolve(null);
      }

      const { value, fileMetadata } = result;
      // Safari can deserialize IndexedDB File values as Blobs without File metadata.
      if (fileMetadata && value instanceof Blob) {
        return resolve(new File([value], fileMetadata.name, fileMetadata));
      }

      resolve(value);
    };
    request.onerror = () => reject(request.error);
  });
}

export async function deleteItem(db, store, key) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(store, 'readwrite');
    let objectStore;
    try {
      objectStore = transaction.objectStore(store);
    } catch {
      resolve(false);
      return;
    }
    const request = objectStore.delete(key);
    request.onsuccess = () => resolve(true);
    request.onerror = () => reject(request.error);
  });
}
